<script lang="ts">
	import { signIn, type SignInAuthorizationParams } from '@auth/sveltekit/client';
	import { page } from '$app/stores';
	import { PUBLIC_BASE_URL } from '$env/static/public';
	import { onMount } from 'svelte';
	import VoiceInLogoWithIcon from '$lib/components/logos/voiceInLogoWithIcon.svelte';

	let isSigningIn: boolean = true;

	function onClickSignIn() {
		startSignIn();
	}

	async function startSignIn() {
		const providerType = 'auth0';

		isSigningIn = true;

		const params: SignInAuthorizationParams = {};
		const options = { callbackUrl: PUBLIC_BASE_URL + $page.url.search, redirect: true };

		try {
			await signIn(providerType, options, params);
		} catch (e) {
		} finally {
			isSigningIn = false;
		}
	}

	onMount(() => {
		startSignIn();
	});
</script>

<div class="flex flex-col h-screen justify-center items-center space-y-7">
	{#if $page.data.session?.user}
		<p>Signed in as {$page.data.session.user.email}</p>
	{:else}
		<VoiceInLogoWithIcon></VoiceInLogoWithIcon>

		{#if isSigningIn}
			<span class="loading loading-spinner loading-lg"></span>
		{:else}
			<button on:click={onClickSignIn}>Sign In</button>
		{/if}
	{/if}
</div>
